import { Inject, Injectable } from '@angular/core';
import { CONSTANTS_REPOSITORY, ConstantsRepository } from '@core/repositories/constants.repository';
import { Constant } from '@shared/interfaces/constant';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {
  constructor(
    @Inject(CONSTANTS_REPOSITORY) protected repository: ConstantsRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  edit(constant: Constant): Observable<any> {
    return this.repository.edit(constant);
  }
}
